import { BusinessRules } from '../BusinessRules';

const rules: Partial<BusinessRules> = {
  mensagemEncargosAtraso:
    'Caso o seu cartão esteja ativo, os encargos decorrentes do atraso não integram a renegociação e serão lançados na próxima fatura, juntamente com as novas despesas. Caso o cartão já esteja cancelado, esses encargos já estão contemplados nos valores do acordo, não havendo cobrança posterior.',
};

export default rules;
